/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import {
  submitRequestDialogStyles as styles,
  default as commonStyles,
} from "../styles";
import ConvoyDialog from "../../../components/ConvoyDialog";
import { useReuploadDbSoftwareBuildScripts } from "../../../api/softwareImages";
import ScriptUploadInput from "./ScriptUploadInput";

const ReuploadDbPatchScriptDialog = ({
  open,
  resetDialog,
  callback,
  buildId,
  steps,
  displayNotification,
}) => {
  const [payload, setPayload] = useState({
    stepName: steps?.[0]?.stepName || "init",
  });

  const {
    postData: reuploadDbSoftwareBuildScripts,
    response: reuploadDbSoftwareBuildScriptsResp,
    responseStatus: reuploadDbSoftwareBuildScriptsStatus,
  } = useReuploadDbSoftwareBuildScripts(buildId);

  const handleDialogConfirm = () => {
    reuploadDbSoftwareBuildScripts(payload);
    resetDialog();
  };

  useEffect(() => {
    if (open) {
      setPayload({ stepName: steps?.[0]?.stepName || "init" });
    }
  }, [open]);
  useEffect(() => {
    displayNotification(
      reuploadDbSoftwareBuildScriptsResp,
      reuploadDbSoftwareBuildScriptsStatus,
      callback
    );
  }, [
    reuploadDbSoftwareBuildScriptsResp,
    reuploadDbSoftwareBuildScriptsStatus,
  ]);

  return (
    <ConvoyDialog
      open={open}
      title="Reupload Scripts"
      handleDialogConfirm={handleDialogConfirm}
      resetDialog={resetDialog}
      disabled={!(payload?.installationScript || payload?.validationScript)}
    >
      <Grid container spacing={1} sx={styles.gridContainer}>
        {["installation", "validation"].map((scriptType) => (
          <Grid item xs={4} key={scriptType} sx={commonStyles.scriptBox}>
            <ScriptUploadInput
              scriptName={scriptType}
              setScript={(fileContent) =>
                setPayload((prev) => ({
                  ...prev,
                  [scriptType + "Script"]: fileContent,
                }))
              }
            />
          </Grid>
        ))}

        <Grid item xs={4}>
          <FormControl sx={styles.formControl}>
            <InputLabel size="string" color="secondary">
              Step To Retry From
            </InputLabel>
            <Select
              fullWidth
              label={"Step"}
              color="secondary"
              value={payload?.stepName}
              onChange={(e) => {
                setPayload((prev) => ({
                  ...prev,
                  stepName: e.target.value,
                }));
              }}
            >
              {steps?.slice(0, 5).map((step, i) => (
                <MenuItem value={step?.stepName} key={i}>
                  {step?.stepName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </ConvoyDialog>
  );
};

export default ReuploadDbPatchScriptDialog;

export const useReuploadDbPatchScriptDialog = (
  callback = () => {},
  displayNotification = () => {}
) => {
  const [open, setOpen] = useState(false);
  const [buildId, setBuildId] = useState({});
  const [steps, setSteps] = useState([]);

  return {
    reuploadDbPatchScriptDialog: (
      <ReuploadDbPatchScriptDialog
        open={open}
        resetDialog={() => setOpen(false)}
        callback={callback}
        displayNotification={displayNotification}
        buildId={buildId}
        steps={steps}
      />
    ),
    setOpenReuploadDbPatchScriptDialog: (buildId, steps) => {
      setOpen(true);
      setBuildId(buildId || "-");
      setSteps(steps || []);
    },
  };
};
